import { TextField } from "@material-ui/core";
import { SearchOutlined, SettingsPhone } from "@material-ui/icons";
import { IconButton, ThemeProvider, Tooltip } from "@mui/material";
import { postRequest } from "api/apiCaller";
import ModalConfirm from "components/modal/ModalConfirm";
import Table from "components/table/Table";
import { useModalState } from "hooks/useModalState";
import { enqueueSnackbar } from "notistack";
import UpdateTicketModal from "pages/agent-dashboard/UpdateTicketModal";
import { useEffect, useMemo, useState } from "react";
import muiTheme from "theme/muiTheme";

import DialogDragable from "../../components/DialogDragable";
import TicketHistoryDetail from "./TicketHistoryDetail";

const TicketHistory = ({ styles, isLoading, ticketHistory, phoneSelected }) => {
  const [tickets, setTickets] = useState([]);
  const [openDialogViewTicket, setOpenDialogViewTicket] = useState(false);
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [ticketData, setTicketData] = useState(null);
  const updateTicketModal = useModalState();
  const updateCallLogModal = useModalState();
  const handleSearchTicketHistory = (e) => {
    const searchValue = e.target.value.toLowerCase();
    if (ticketHistory?.length && searchValue) {
      const newListTickets = ticketHistory.filter(
        (item) =>
          item.sourceName?.toLowerCase().includes(searchValue) ||
          item.channel?.toLowerCase().includes(searchValue) ||
          item.ticketType?.name?.toLowerCase().includes(searchValue) ||
          item.statusText?.toLowerCase().includes(searchValue) ||
          item.attributes?.packageCode?.toLowerCase().includes(searchValue)
      );
      setTickets(newListTickets);
    } else {
      setTickets(ticketHistory);
    }
  };
  const columns = useMemo(
    () => [
      {
        id: "createdTime",
        type: "datetime",
        name: "Thời gian",
      },
      {
        id: "subject",
        name: "Tiêu đề",
      },
      {
        id: "status",
        name: "Trạng thái",
      },
    ],
    []
  );
  const handleViewRecordDetail = (record) => {
    setTicketData(record);
    setOpenDialogViewTicket(true);
  };
  const handleEditRecordDetail = (record) => {
    setSelectedTicket(record);
    updateTicketModal.openModal();
  };
  const handleCloseUpdateTicketModal = () => {
    updateTicketModal.closeModal();
  };

  const handleOpenModalChangeCallLog = (record) => {
    console.log("🚀  record ==", record);
    setSelectedTicket(record);
    updateCallLogModal.openModal();
  };
  const handleCloseModalChangeCallLog = () => {
    updateCallLogModal.closeModal();
  };

  const handleChangeCallLog = () => {
    postRequest(`/mini-crm-v2/api/v1/ticket/assign-call`, {
      ticketId: selectedTicket.id,
      cdrId: phoneSelected.cdrId,
    })
      .then((res) => {
        if (res.data) {
          handleCloseModalChangeCallLog();
          enqueueSnackbar("Lưu thông tin ticket thành công", {
            variant: "success",
          });
        } else {
          enqueueSnackbar("Lưu thông tin ticket thất bại!", {
            variant: "error",
          });
        }
      })
      .catch((err) =>
        enqueueSnackbar(
          `Lưu thông tin ticket thất bại! ${
            err.response?.data?.error?.message || err.message || ""
          }`,
          {
            variant: "error",
          }
        )
      );
  };

  useEffect(() => {
    setTickets(ticketHistory);
  }, [ticketHistory]);

  return (
    <>
      <ThemeProvider theme={muiTheme}>
        <div
          className={styles.center}
          style={{
            justifyContent: "space-between",
            marginBottom: 10,
          }}>
          <span className={styles.textTitle}>Lịch sử tương tác</span>
          <TextField
            variant="standard"
            InputProps={{
              spellCheck: "false",
              startAdornment: <SearchOutlined />,
              classes: {
                input: styles.textFieldInputRoot,
              },
            }}
            style={{ width: 350, fontWeight: 400 }}
            placeholder="Tìm kiếm lịch sử tương tác"
            onChange={handleSearchTicketHistory}
          />
        </div>
        {/* <Table>
        <TableHead>
          <TableRow>
            <TableCell className={styles.tableCell}>Thời gian</TableCell>
            <TableCell className={styles.tableCell}>Nguồn kênh</TableCell>
            <TableCell className={styles.tableCell}>Kênh</TableCell>
            <TableCell className={styles.tableCell}>Yêu cầu</TableCell>
            <TableCell className={styles.tableCell}>Trạng thái</TableCell>
            <TableCell className={styles.tableCell}>Mã giao dịch</TableCell>
            <TableCell className={styles.tableCell}>Hành động</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {isLoading && (
            <TableRow style={{ border: "none" }}>
              <TableCell
                colSpan={7}
                style={{ border: "none", paddingTop: 25, paddingBottom: 25 }}
                align="center">
                <CircularProgress />
              </TableCell>
            </TableRow>
          )}
          {!isLoading && (
            <>
              {idTicketPhone && tickets && tickets.length > 0 ? (
                tickets.map((item, key) => (
                  <TableRow key={key}>
                    <TableCell className={styles.tableCell}>
                      {datetimeHelper.toFormat(
                        item.createdAt,
                        "YYYY-MM-DD HH:mm:ss"
                      )}
                    </TableCell>
                    <TableCell className={styles.tableCell}>
                      {item.sourceName || ""}
                    </TableCell>
                    <TableCell className={styles.tableCell}>
                      {item.channel || ""}
                    </TableCell>
                    <TableCell className={styles.tableCell}>
                      {item.ticketType?.name || ""}
                    </TableCell>
                    <TableCell className={styles.tableCell}>
                      {item.statusText || ""}
                    </TableCell>
                    <TableCell className={styles.tableCell}>
                      {item.attributes?.packageCode || ""}
                    </TableCell>
                    <TableCell>
                      <div>
                        <Fab
                          color="primary"
                          aria-label="add"
                          size="small"
                          onClick={() => {
                            setTicketData(item);
                            setOpenDialogViewTicket(true);
                          }}>
                          <Visibility />
                        </Fab>
                      </div>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow style={{ border: "none" }}>
                  <TableCell
                    colSpan={7}
                    style={{
                      border: "none",
                      paddingTop: 35,
                      paddingBottom: 25,
                    }}
                    align="center">
                    <i
                      className="fal fa-frown"
                      style={{ fontSize: 45, color: "#ccc" }}></i>
                    <Typography
                      className={styles.text}
                      style={{ textAlign: "center", color: "#8d8d8d" }}>
                      Rất tiếc, chúng tôi hiện tại không tìm thấy bản ghi ticket
                      nào
                    </Typography>
                  </TableCell>
                </TableRow>
              )}
            </>
          )}
        </TableBody>
      </Table> */}
        <Table
          columns={columns}
          data={tickets}
          loading={isLoading}
          actionColumn={{
            onView: handleViewRecordDetail,
            colorButtonView: "primary",
            onEdit: handleEditRecordDetail,
            colorButtonEdit: "primary",
            customActions: (record) => {
              return (
                phoneSelected.crmCallId && (
                  <Tooltip title="Gắn log cuộc gọi">
                    <IconButton
                      onClick={() => handleOpenModalChangeCallLog(record)}
                      color="primary">
                      <SettingsPhone />
                    </IconButton>
                  </Tooltip>
                )
              );
            },
          }}
        />
        <DialogDragable
          open={openDialogViewTicket}
          onClose={() => setOpenDialogViewTicket(false)}
          title={
            <span>
              Xem thông tin ticket{" "}
              <span style={{ fontSize: 20, color: "red" }}>
                {ticketData?.attributes?.packageCode || ""}
              </span>
            </span>
          }>
          <TicketHistoryDetail ticketData={ticketData} />
        </DialogDragable>
        {updateTicketModal.open && (
          <UpdateTicketModal
            open={updateTicketModal.open}
            onClose={handleCloseUpdateTicketModal}
            data={selectedTicket}
            title={`Cập nhật ticket: ${selectedTicket?.subject}`}
          />
        )}
        {updateCallLogModal.open && (
          <ModalConfirm
            open={updateCallLogModal.open}
            onClose={handleCloseModalChangeCallLog}
            onConfirm={handleChangeCallLog}
            title={"Gắn log cuộc gọi cho ticket này ?"}
            titleButtonAgree="Đồng ý"
          />
        )}
      </ThemeProvider>
    </>
  );
};

export default TicketHistory;
